import cls from 'classnames';

import useStyles from './bulletStyles';
import { BulletColor } from './types';

export default function Bullet({
  isActive,
  onClick,
  color,
}: {
  isActive?: boolean;
  onClick?: () => void;
  color: BulletColor;
}) {
  const classes = useStyles({ color });

  return (
    <span
      className={cls(classes.root, isActive && classes.isActive)}
      onClick={isActive ? undefined : onClick}
    />
  );
}
